export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11084.10a1a162.jpg";